import React, { useEffect, useState } from "react";
import { apiCall } from "../../_services/apiCall";
import config from "../../config/config";
import { Modal, ModalHeader } from "../../globalComponents/ui/Modal";
import { PrimaryButton, SecondaryButton } from "../../globalComponents/ui/Button";
import {
  SettingsPage,
  SettingsTopBar, SettingsTopBarLeft,
  SettingsAccentBar, SettingsTopBarTitle, SettingsTopBarSub,
  SettingsContent,
  SettingsCard, SettingsSectionHeader, SettingsSectionTitle, SettingsCountChip,
  SettingsModalBody, SettingsModalFooter,
  SettingsFormGroup, SettingsFormLabel, SettingsFormSelect,
} from "./SettingShell";
import DataTable from "../../globalComponents/ui/DataTable/DataTable";

const CompanyGWP = () => {
  const [show, setShow] = useState(false);
  const [currentModuleId, setCurrentModuleId] = useState(null);
  const [frequency, setFrequency] = useState("");
  const [data, setData] = useState([]);

  const handleClose = () => setShow(false);

  const getFinancialYear = async () => {
    const storedData = localStorage.getItem('financialYearData');
    if (storedData) {
      const parsedData = JSON.parse(storedData);
      return parsedData[parsedData.length - 1].id;
    } else {
      const { isSuccess, data } = await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}getFinancialYear`, {}, {});
      if (isSuccess) {
        localStorage.setItem('financialYearData', JSON.stringify(data.data));
        return data.data[data.data.length - 1].id;
      }
    }
  };

  const fetchFrameworkApi = async () => {
    const { isSuccess, data } = await apiCall(`${config.POSTLOGIN_API_URL_COMPANY}getFramework`, {}, { type: "ALL" });
    if (isSuccess) {
      return data?.data.map((item) => item.id);
    }
  };

  const getReportingQuestions = async () => {
    const financialYearId = await getFinancialYear();
    try {
      const response = await apiCall(
        `${config.POSTLOGIN_API_URL_COMPANY}getFrequencyModule`,
        {},
        { frameworkIds: await fetchFrameworkApi(), financialYearId },
        "GET"
      );
      if (response.isSuccess) {
        setData(response.data.data || []);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getReportingQuestions();
  }, []);

  const editItem = (item) => {
    setCurrentModuleId(item.moduleId);
    setFrequency(item.frequencies);
    setShow(true);
  };

  const handleSave = async () => {
    const financialYearId = await getFinancialYear();
    const { isSuccess } = await apiCall(
      config.POSTLOGIN_API_URL_COMPANY + `saveFrequencyModule`,
      {},
      { financialYearId, moduleId: currentModuleId, frequency: frequency },
      "POST"
    );
    if (isSuccess) {
      handleClose();
      getReportingQuestions();
    }
  };

  return (
    <SettingsPage>
      <SettingsTopBar>
        <SettingsTopBarLeft>
          <SettingsAccentBar />
          <div>
            <SettingsTopBarTitle>Question Frequency</SettingsTopBarTitle>
            <SettingsTopBarSub>Set reporting intervals for different modules</SettingsTopBarSub>
          </div>
        </SettingsTopBarLeft>
      </SettingsTopBar>

      <SettingsContent $wide>
        <SettingsCard>
          <SettingsSectionHeader>
            <i className="fas fa-clock" style={{ fontSize: 12, color: "#3f88a5" }} />
            <SettingsSectionTitle>Module Frequencies</SettingsSectionTitle>
            <SettingsCountChip>{data.length}</SettingsCountChip>
          </SettingsSectionHeader>
          <DataTable
            title=""
            searchable={false}
            showPagination={false}
            columns={[
              { key: "moduleName", label: "Module Name", sortable: true },
              {
                key: "frequencies",
                label: "Current Frequency",
                renderCell: (value) => (
                  <span style={{ padding: "4px 10px", borderRadius: 6, fontSize: 11, fontWeight: 600, background: "#f1f5f9", color: "#475569", textTransform: "capitalize" }}>
                    {typeof value === "string" ? value.replace(/_/g, " ").toLowerCase() : value}
                  </span>
                ),
              },
            ]}
            data={data.map((item, index) => ({ _id: item.moduleId, moduleName: item.moduleName, frequencies: item.frequencies, _isLast: index === data.length - 1, _raw: item }))}
            emptyMessage="No module frequencies found."
            extraActions={(row) => [
              { label: "Edit", icon: "fas fa-edit", variant: row._isLast ? "edit" : "view", onClick: () => editItem(row._raw) },
            ]}
          />
        </SettingsCard>
      </SettingsContent>

      <Modal show={show} onClose={handleClose} maxWidth={400}>
        <ModalHeader icon="fas fa-clock" title="Edit Frequency" />
        <SettingsModalBody>
          <SettingsFormGroup>
            <SettingsFormLabel>Select Frequency</SettingsFormLabel>
            <SettingsFormSelect 
              value={frequency} 
              onChange={(e) => setFrequency(e.target.value)}
            >
              <option value="">Select Frequency</option>
              <option value="MONTHLY">Monthly</option>
              <option value="QUARTERLY">Quarterly</option>
              <option value="HALF_YEARLY">Half Yearly</option>
              <option value="YEARLY">Yearly</option>
            </SettingsFormSelect>
          </SettingsFormGroup>
        </SettingsModalBody>
        <SettingsModalFooter>
          <SecondaryButton onClick={handleClose}>Cancel</SecondaryButton>
          <PrimaryButton onClick={handleSave} disabled={!frequency}>Save Changes</PrimaryButton>
        </SettingsModalFooter>
      </Modal>
    </SettingsPage>
  );
};

export default CompanyGWP;